import { LoggerLevel, LoggerPublisher } from "@board/cloud-library/components/services";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class LocalStoragePublisher implements LoggerPublisher {
  constructor() {}

  private logEntrisLimit = 25;
  private storageLocation = "brdApplicationLog";

  log(level: LoggerLevel, preMessage: string, message: string, correlation: string, extraData: unknown[]): void {
    correlation = correlation || "0000";

    try {
      // reidrato
      const values: Array<string> = JSON.parse(localStorage.getItem(this.storageLocation)) || [];

      // aggiungo in testa
      const extraDataString = extraData ? extraData.join("\n") : "";
      values.unshift(`${preMessage} ${message}\n${extraDataString}`);

      // elimino l'eventuale eccedenza da sotto
      if (values.length > this.logEntrisLimit) {
        values.pop();
      }

      localStorage.setItem(this.storageLocation, JSON.stringify(values));
    } catch (ex) {
      console.log("Error in saving in localStorage");
    }
  }

  clear(): void {
    localStorage.removeItem(this.storageLocation);
  }
}
